(() => {
  'use strict';

  const MOBILE = '(max-width: 749px)';

  function initStickyCart() {
    if (!document.body.classList.contains('template-cart') || document.querySelector('.dv-sticky-cart')) return;
    const checkout = document.querySelector('#checkout, .cart__checkout-button[name="checkout"]');
    const total = document.querySelector('.totals__total-value');
    if (!checkout || !total) return;
    const bar = document.createElement('aside');
    bar.className = 'dv-sticky-cart';
    bar.dataset.visible = 'false';
    bar.setAttribute('aria-label', 'Flýtiaðgerð fyrir körfu');
    bar.innerHTML = '<span class="dv-sticky-cart__total"></span><button type="button" class="dv-sticky-cart__button">Ganga frá kaupum</button>';
    document.body.appendChild(bar);
    const stickyTotal = bar.querySelector('.dv-sticky-cart__total');
    const button = bar.querySelector('.dv-sticky-cart__button');
    const sync = () => {
      stickyTotal.textContent = total.textContent.replace(/\s+/g, ' ').trim();
      button.disabled = checkout.disabled || checkout.getAttribute('aria-disabled') === 'true';
    };
    button.addEventListener('click', () => { if (!button.disabled) checkout.click(); });
    const visibility = () => {
      const rect = checkout.getBoundingClientRect();
      bar.dataset.visible = String(window.matchMedia(MOBILE).matches && (rect.bottom < 0 || rect.top > window.innerHeight));
    };
    if (checkout instanceof Node) {
      new IntersectionObserver(visibility, { threshold: 0.05 }).observe(checkout);
    }
    if (total instanceof Node) {
      new MutationObserver(sync).observe(total, { childList: true, subtree: true });
    }
    window.addEventListener('scroll', visibility, { passive: true });
    sync();
    visibility();
  }

  const weightPattern = /\b\d+(?:[.,]\d+)?\s*(?:kg|g|gr\.?)(?=\b|\s|$)/gi;
  const normalizedFamily = (title) => title.toLocaleLowerCase('is').replace(weightPattern, '').replace(/[–—-]+\s*$/g, '').replace(/\s+/g, ' ').trim();
  const sizeLabel = (title) => title.match(weightPattern)?.[0]?.replace(/\s+/g, ' ') || '';

  async function initSiblingSizes() {
    const root = document.querySelector('[data-dv-next20-sizes]');
    if (!root) return;
    const links = root.querySelector('.dv-next20-sizes__links');
    if (links.children.length) { root.hidden = false; return; }
    const currentFamily = normalizedFamily(root.dataset.productTitle || '');
    if (!currentFamily || !root.dataset.productId) return;
    try {
      const prefix = window.Shopify?.routes?.root || '/';
      const url = `${prefix}recommendations/products.json?product_id=${encodeURIComponent(root.dataset.productId)}&limit=10&intent=related`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const payload = await response.json();
      const siblings = (payload.products || []).filter((candidate) => {
        return candidate.handle !== root.dataset.productHandle
          && candidate.vendor === root.dataset.productVendor
          && normalizedFamily(candidate.title || '') === currentFamily
          && Boolean(sizeLabel(candidate.title || ''));
      });
      siblings.slice(0, 5).forEach((sibling) => {
        const link = document.createElement('a');
        link.href = `${prefix}products/${sibling.handle}`;
        link.textContent = sizeLabel(sibling.title) || sibling.title;
        link.setAttribute('aria-label', `Velja ${sibling.title}`);
        links.appendChild(link);
      });
      root.hidden = links.children.length === 0;
    } catch (_) {
      root.hidden = true;
    }
  }

  const copyCorrections = {
    'taste-of-the-wild-pacific-stream-hvolpa-og-fullordinsfodur-lax-2kg': [
      ['fyrir ketti með viðkvæma meltingu eða fæðuóþol', 'fyrir hunda með viðkvæma meltingu eða fæðuóþol'],
      ['fyrir ketti með viðkvæma meltingu eða fæðuofnæmi', 'fyrir hunda með viðkvæma meltingu eða fæðuofnæmi'],
    ],
    'taste-of-the-wild-pacific-stream-hvolpa-og-fullordinsfodur-lax-12-2kg': [
      ['fyrir ketti með viðkvæma meltingu eða fæðuóþol', 'fyrir hunda með viðkvæma meltingu eða fæðuóþol'],
      ['fyrir ketti með viðkvæma meltingu eða fæðuofnæmi', 'fyrir hunda með viðkvæma meltingu eða fæðuofnæmi'],
    ],
    'taste-of-the-wild-pacific-stream-hvolpa-og-fullordinsfodur-lax-170g': [
      ['fyrir ketti með viðkvæma meltingu eða fæðuóþol', 'fyrir hunda með viðkvæma meltingu eða fæðuóþol'],
      ['fyrir ketti með viðkvæma meltingu eða fæðuofnæmi', 'fyrir hunda með viðkvæma meltingu eða fæðuofnæmi'],
    ],
    'taste-of-the-wild-sierra-mountain-hundafodur-lamb-2kg': [
      ['kötturinn fái úrvals prótein', 'hundurinn fái úrvals prótein'],
    ],
    'taste-of-the-wild-sierra-mountain-hundafodur-lamb-12-2kg': [
      ['þróuð fyrir ketti', 'þróuð fyrir hunda'],
    ],
    'taste-of-the-wild-wetlands-adult-hundafodur-ond-2kg': [
      ['hönnuð fyrir ketti', 'hönnuð fyrir hunda'],
      ['veitir kettinum þínum', 'veitir hundinum þínum'],
    ],
    'taste-of-the-wild-wetlands-adult-hundafodur-ond-170g': [
      ['hönnuð fyrir ketti', 'hönnuð fyrir hunda'],
    ],
    'taste-of-the-wild-southwest-canyon-hundafodur-naut-og-villisvin-170g': [
      ['hönnuð fyrir ketti', 'hönnuð fyrir hunda'],
    ],
  };

  function correctConfirmedProductCopy() {
    if (!document.body.classList.contains('template-product')) return;
    const productHandle = document.body.dataset.productHandle
      || document.querySelector('[data-dv-next20-sizes]')?.dataset.productHandle
      || window.location.pathname.match(/^\/products\/([^/?#]+)/)?.[1];
    const corrections = copyCorrections[productHandle];
    if (!corrections) return;
    const walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (/Ef þú vilt bæta við upplýsingum um að þetta sé/i.test(node.textContent || '')) {
        const block = node.parentElement?.closest('.multicolumn-card, .product-info-row, li, article, div');
        if (block) block.hidden = true;
        return;
      }
      let text = node.textContent;
      corrections.forEach(([from, to]) => { text = text.replaceAll(from, to); });
      if (text !== node.textContent) node.textContent = text;
    });
    document.body.dataset.dvCopyAudit = 'corrected';
  }

  function improvePredictiveSearch() {
    document.querySelectorAll('predictive-search input[type="search"], .search-modal input[type="search"]').forEach((input) => {
      if (!input.getAttribute('aria-describedby')) {
        const id = `DvSearchHelp-${Math.random().toString(36).slice(2)}`;
        const help = document.createElement('span');
        help.id = id;
        help.className = 'visually-hidden';
        help.textContent = 'Leitaðu eftir vörumerki, próteini, stærð eða verði.';
        input.insertAdjacentElement('afterend', help);
        input.setAttribute('aria-describedby', id);
      }
    });
  }

  function focusCollectionFilter() {
    const focus = new URLSearchParams(window.location.search).get('dv_focus');
    if (!document.body.classList.contains('template-collection')) return;

    const filterNames = {
      'ingredient-exclusions': 'filter.p.m.dyr.laust_vid',
      'protein-source': 'filter.v.t.shopify.pet-food-flavor',
    };
    const inputName = filterNames[focus];
    if (!inputName) return;

    const mobileSelectors = {
      'ingredient-exclusions': '[data-dv-ingredient-exclusions-mobile]',
      'protein-source': '[data-dv-protein-filter-mobile]',
    };
    const mobileDisclosure = document.querySelector(mobileSelectors[focus]);
    const mobileDrawer = mobileDisclosure?.closest('.mobile-facets__disclosure');
    if (
      window.matchMedia(MOBILE).matches
      && mobileDisclosure instanceof HTMLDetailsElement
      && mobileDrawer instanceof HTMLDetailsElement
    ) {
      const mobileSummary = mobileDisclosure.querySelector(':scope > summary');
      const drawerSummary = mobileDrawer.querySelector(':scope > summary');
      if (!(mobileSummary instanceof HTMLElement)) return;
      if (!mobileDrawer.open && drawerSummary instanceof HTMLElement) drawerSummary.click();
      if (!mobileDrawer.open) mobileDrawer.open = true;
      mobileDrawer.classList.add('menu-opening');
      mobileDisclosure.open = true;
      mobileDrawer.classList.add('dv-facet-drawer-focus');
      mobileDisclosure.classList.add('dv-facet-filter-focus');
      window.requestAnimationFrame(() => {
        mobileSummary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        mobileSummary.focus({ preventScroll: true });
      });
      window.setTimeout(() => {
        mobileDrawer.classList.remove('dv-facet-drawer-focus');
        mobileDisclosure.classList.remove('dv-facet-filter-focus');
      }, 6000);
      return;
    }

    const input = document.querySelector(`#FacetFiltersForm input[name="${inputName}"]`);
    const disclosure = input?.closest('details.js-filter, details');
    const summary = disclosure?.querySelector(':scope > summary');
    if (!(disclosure instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) return;

    disclosure.open = true;
    disclosure.classList.add('dv-facet-filter-focus');
    window.requestAnimationFrame(() => {
      summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      summary.focus({ preventScroll: true });
    });
    window.setTimeout(() => disclosure.classList.remove('dv-facet-filter-focus'), 6000);
  }

  function init() {
    document.body.dataset.dvNext20 = 'ready';
    initStickyCart();
    initSiblingSizes();
    correctConfirmedProductCopy();
    improvePredictiveSearch();
    focusCollectionFilter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
